enum SMHExceptionCodeType {
  'NoRequiredParam' = 'NoRequiredParam',
}

class SMHException {
  code: SMHExceptionCodeType;

  message: string;

  constructor(code: SMHExceptionCodeType, message?: string) {
    this.code = code;
    this.message = message || code;
  }
}

export default SMHException;

export { SMHExceptionCodeType };

export interface SerializedError {
  readonly $isError: true;
  readonly name: string;
  readonly code: string;
  readonly message: string;
  readonly stack: string;
}

export function transformErrorForSerialization(error: Error): SerializedError;
export function transformErrorForSerialization(error: any): any;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function transformErrorForSerialization(error: any): any {
  if (error instanceof Error) {
    const { name, message } = error;
    const stack: string = (<any>error).stacktrace || (<any>error).stack;
    return {
      $isError: true,
      name,
      code: message,
      message,
      stack,
    };
  }
  if (typeof error === 'string') {
    return {
      code: error,
      message: error,
    };
  }

  // return as is
  return error;
}
